<template>
    <Multiselect v-if="birds !== null"
        class="multi-select"
        v-model="selectedBird"
        :placeholder="placeholderText"
        :options="birds"
        :searchable="true"
        :canClear="false"
        @search-change="searchQuery"
        @select="onSelectBird"
    />
</template>


<script>
import axios from 'axios';
import {paths} from '@/globalVariables';
import Multiselect from '@vueform/multiselect';


//import Vue from "vue"

export default {
    props:{
        placeholderText: {
            type: String,
            default: "Søg på artsnavn"
        },
        loadBirdOnSelect: {
            type: Boolean,
            default: false
        },
        loadBirds: {
            type: Boolean,
            default: false
        },
        /** If emitSelection is true, use it like this: @selection="someMethod" */
        emitSelection: {
            type: Boolean,
            default: false
        },
        sortSystematically: {
            type: Boolean,
            default: false
        },
        preselectBird: {
            type: Boolean,
            default: false
        },
        height: {
            type: String,
            default: '38px'
        },
        inFocusColor: {
            type: String,
            default: '#fff'
        },
        borderColor: {
            type: String,
            default: "#d1d5db"
        },
        caretColor: {
            type: String,
            default: "#999"
        },
        placeholderColor: {
            type: String,
            default: "var(--ms-placeholder-color,#9ca3af)"
        },
        optionHoverColor: {
            type: String,
            default: "var(--ms-option-bg-pointed, #f3f4f6)"
        }

    },
    data() {
        return {
            birds: null,
            birdsAlphabeticallySorted: null,
            birdsSystematicallySorted: null,

            selectedBird: null,
        }
    },
    components: {
        Multiselect,
    },

    watch:{
        loadBirds: {
            handler(loadBirds) {
                if (loadBirds) {
                    if (this.birds === null) {
                        this.getAlphabeticallySortedBirds();
                    }
                }
            }
        },
        sortSystematically: {
            handler(sortSystematically) {
                if (sortSystematically) {
                    this.setSystematicallySorting();
                } else {
                    this.setAlphabeticallySorting();
                }
            }
        }
    },

    async created() {
        if (this.loadBirds) {
            this.getAlphabeticallySortedBirds();
        }
    },
    methods: {
        async getAlphabeticallySortedBirds() {
            // Get list of birds from api
            const response = await axios.get(paths.api.open.BIRD_LIST_ALPHABETICALLY, {});
            this.birdsAlphabeticallySorted = response.data;
            this.setAlphabeticallySorting();
        },
        setAlphabeticallySorting(){
            this.birds = this.birdsAlphabeticallySorted;
            this.selectFirstBird();
        },

        async setSystematicallySorting() {
            if (this.birdsSystematicallySorted === null) {
                await this.getSystematicallySortedBirds()
            }
            this.birds = this.birdsSystematicallySorted;
            this.selectFirstBird();
        },
        async getSystematicallySortedBirds() {
            const response = await axios.get(paths.api.open.BIRD_LIST_SYSTEMATICALLY, {})
            this.birdsSystematicallySorted = response.data; 
        },

        selectFirstBird() {
            if (this.preselectBird) {
                this.selectedBird = this.birds[0].value;
                
                if (this.emitSelected)
                    this.emitSelected(this.selectedBird);
            }
        },


        searchQuery(value) {
            //const allBirds = this.useSystematicSort ? this.birdsSystematicallySorted : this.birdsAlphabeticallySorted;
            if (this.birdsAlphabeticallySorted === null) {
                return;
            }
       
            let foundBirds = []

            // ^ = start of string, i = case insensitive
            let pattern = new RegExp('^'+value+'[a-zæøåA-ZÆØÅ ]*', "i");           
            for (let bird of this.birdsAlphabeticallySorted) {
                //console.log(bird)
                if(bird.label !== null && bird.label.match(pattern) !== null) {
                    foundBirds.push(bird)
                }
            }

            // (?<!^) = not at beginning of string
            let pattern2 = new RegExp('(?<!^)' + value, "i"); 
            for (let bird of this.birdsAlphabeticallySorted) {
                if(bird.label !== null && bird.label.match(pattern2) !== null) {
                    foundBirds.push(bird)
                }
            }

            this.birds = foundBirds
        },

        loadSelectedOnClick() {
            if (this.loadBirdOnSelect) {
                this.loadSelected(this.selectedBird);
            }
        },
        loadSelectedOnEnter(value) {
            if (this.loadBirdOnSelect) {
                this.loadSelected(value);
            }
        },
        onSelectBird(value) {
            if (this.emitSelection) {
                this.emitSelected(value);
            } else {
                this.loadSelected(value);
            }
        },
        emitSelected(value) {
            this.$emit("selection", value);
        },
        loadSelected(value) {
            this.$router.push({ 
                name: 'BirdView',
                params: { id: value},
            })
        },

    }

}
</script>

<style scoped>
.multi-select{
    --ms-option-bg-selected-pointed: #768fb3; /* #4779AE */
    --ms-option-bg-selected: #768fb3;
    --ms-option-bg-pointed: v-bind(optionHoverColor);
    --ms-ring-color: v-bind(inFocusColor);

    width: 100%;
    height: 100%;
}

/* .multiselect defined by vueform */
.multiselect{
    min-height: v-bind(height);
    border: 1px solid v-bind(borderColor);
}
:deep(.multiselect-caret) {
    background-color: v-bind(caretColor);
}
:deep(.multiselect-placeholder){
    color: v-bind(placeholderColor);
}

</style>